import React, { useState, useEffect } from "react";

import sweetAlert from "sweetalert";

import { inhabitantsAPI } from "services/inhabitantsAPI";
import { Form, Loading } from "components";

export function Segments({ onChange, value, isMulti = false, disabled }) {
  const [segments, setSegments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    inhabitantsAPI
      .get("/experience/segments")
      .then(({ data }) => {
        if (!data || !data.data) {
          return;
        }

        if (Array.isArray(data.data)) {
          setSegments(
            data.data.map(({ attributes }) => ({
              id: attributes.id,
              name: attributes.name,
            }))
          );
        }
      })
      .catch((error) => {
        sweetAlert(
          "Algo deu errado!",
          "Não foi possível buscar os dados de segmentos. Por favor, recarregue a página ou tente fazer o login novamente.",
          "error"
        );
        console.error(error);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <Form.Select
      placeholder="Nenhum segmento selecionado"
      isMulti={isMulti}
      disabled={disabled}
      onChange={onChange}
      value={value}
      options={segments.map((segment) => ({
        value: segment.id,
        label: segment.name,
      }))}
    />
  );
}
